

export default {
  namespaced: true,
  state: {
      payment:0
  },
  getters:{},
  mutations: {
      changePayment(state,n){

          state.payment = n;
      }
  },
  actions:{}
}



// WEBPACK FOOTER //
// ./src/store/modules/controller.js